// Mirrors backend/utils/prescriptionQuantity.js exactly — same formula, same
// SOS/STAT special case, same "missing frequency/duration rounds down"
// rule. The backend is the authoritative write path (it derives a value on
// save regardless of what the client sent), but computing the same default
// here too means the doctor sees a sensible Quantity as soon as dose/
// frequency/duration are filled in, not only after a save + refetch.
import type { PrescriptionItemInput } from './types';

const DOSES_PER_DAY: Record<string, number> = { OD: 1, BD: 2, TDS: 3, QID: 4, HS: 1 };
const DAYS_PER_UNIT: Record<string, number> = { d: 1, wk: 7, mo: 30 };

export function deriveQuantity(item: Pick<PrescriptionItemInput, 'dose_quantity' | 'frequency_code' | 'duration_value' | 'duration_unit'>): number | null {
  const dose = item.dose_quantity;
  if (dose == null || !Number.isFinite(dose) || dose <= 0) return null;

  const code = (item.frequency_code || '').trim().toUpperCase();
  if (code === 'SOS' || code === 'STAT') return Math.max(1, Math.ceil(dose));

  const durationValue = item.duration_value;
  const days = durationValue != null && Number.isFinite(durationValue) && durationValue > 0
    ? durationValue * (DAYS_PER_UNIT[item.duration_unit || 'd'] || 1)
    : 1;

  return Math.max(1, Math.ceil(dose * (DOSES_PER_DAY[code] || 1) * days));
}
